// src/App.js
import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import './assets/styles/global.css';

// Components
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';

// Pages
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import Team from './pages/Team';
import Programs from './pages/Programs';
import Support from './pages/Support';
import Impact from './pages/Impact';
import Contact from './pages/Contact';
import ExecutiveTeam from './pages/Executiveteam';
import LeadershipTeam from './pages/Leadershipteam';
import Campaign from './pages/Campaign';

// Project Pages
import OneOutreachForAll from './pages/projects/OneOutreachForAll';
import SGBVProject from './pages/projects/SGBVProject';
import NCDHIVIntegration from './pages/projects/NCDHIVIntegration';
import CancerProject from './pages/projects/RCASRProject';
import RGHDProject from './pages/projects/RGHDProject';
import RHASMPProject from './pages/projects/RHASMPProject';
import RakaiT1DProject from './pages/projects/RakaiT1D';
import OVCProject from './pages/projects/OvcProject';

function App() {
  useEffect(() => {
    // Initialize AOS animations
    if (window.AOS) {
      window.AOS.init({
        duration: 1000,
        once: true,
        offset: 100
      });
    }
  }, []);

  return (
    <Router>
      <div className="App">
        <Navbar />
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<Services />} />
          <Route path="/team" element={<Team />} />
          <Route path="/support_us" element={<Support />}/>
          <Route path="/programs" element={<Programs />} />
          <Route path="/impact" element={<Impact />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/campaign" element={<Campaign />} />
          <Route path="/team/board" element={<ExecutiveTeam />} />
          <Route path="/team/executive" element={<LeadershipTeam />} />
          
          {/* Project Routes */}
          <Route path="/projects/one-outreach" element={<OneOutreachForAll />} />
          <Route path="/projects/sgbv" element={<SGBVProject />} />
          <Route path="/projects/rghd-project" element={<RGHDProject />} />
          <Route path="/projects/ncd-hiv" element={<NCDHIVIntegration />} />
          <Route path="/projects/rcasr" element={<CancerProject />} />
          <Route path="/projects/rhasmp" element={<RHASMPProject />} />
          <Route path="/projects/rakai-t1d" element={<RakaiT1DProject />} />
          <Route path="/projects/ovc" element={<OVCProject />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;